module.exports = __webpack_public_path__ + "img/google-play-badge.25d51e50.png";